import { render, staticRenderFns } from "./Coachmodification.vue?vue&type=template&id=9b912364&scoped=true&"
import script from "./Coachmodification.vue?vue&type=script&lang=js&"
export * from "./Coachmodification.vue?vue&type=script&lang=js&"
import style0 from "./Coachmodification.vue?vue&type=style&index=0&id=9b912364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b912364",
  null
  
)

export default component.exports